import React from 'react';
import './contactUs.less'

function ContactUs() {

  return (
    <div className="contactUs" id="contactUs">
      <h3> 联系我们 </h3>
      <form method="post" action="http://www.argylehotels.com/index.php?m=formguide&c=index&a=show&formid=217&siteid=12">
      <ul>
        <li>
          <span> 姓 名 </span> <input placeholder="请输入您的姓名" type="text" name="info[name]" />
        </li>
        <li>
          <span> 投资规模 </span> 
          <select name="info[scale]" id="">  
            <option value="1000-3000万"> 1000-3000万 </option>
            <option value="3000-5000万"> 3000-5000万 </option>
            <option value="5000-10000万"> 5000-10000万 </option>
            <option value="1亿以上"> 1亿以上 </option>
          </select>
        </li>
        <li>
          <span> 电 话 </span> <input placeholder="请输入您的联系方式" type="text" name="info[tel]" />
        </li>
        <li>
          <span> 建筑面积 </span> 
          <select name="info[area]" id="">  
            <option value="8000-15000平方米"> 8000-15000平方米 </option>
            <option value="15000-20000平方米"> 15000-20000平方米 </option>
            <option value="20000平方米以上"> 20000平方米以上 </option>
          </select>
        </li>
        <li>
          <span> 城 市 </span> <input placeholder="请输入您的城市" type="text" name="info[city]"/>
        </li>
        <li>
          <span> 物业状态 </span> 
          <select name="info[wyzt]" id="">  
            <option value="新建持有"> 新建持有 </option>
            <option value="租赁"> 租赁 </option>
            <option value="旧楼改造"> 旧楼改造 </option>
            <option value="其他"> 其他 </option>
          </select>
        </li>
      </ul>
      <div className="others">
        <span> 其他说明 </span> <input placeholder="请输入其他说明" type="text" name="info[qt]"/>
      </div>
      <div className="button">
        <button type="reset"> 重 &nbsp; 置 </button>
        <button type="submit"  name="dosubmit" id="sub"> 提 &nbsp; 交 </button>
      </div>
      </form>
    </div>
  );
}

export default ContactUs;